<template>
  <div class="has-border-b filters white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="filters-item filters-item--search filters-item--reset">
      <v-text-field
        v-model="phone"
        :placeholder="$t(`${namespace}.searchByPhone`)"
        prepend-inner-icon="search"
        :disabled="isLoading"
        :loading="searchIsLoading"
        color="accent"
        height="36"
        flat
        solo
        clearable
        hide-details
        maxlength="15"
        @input="($event) => setPhoneMask($event, 'phone')"
        @paste="($event) => setPhoneMask($event, 'phone')"
        @click:clear="reset"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { masks } from 'utils/masks'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.SearchPhonePage',
      phone: null,
      filters: {
        search: null
      }
    }
  },
  methods: {
    setPhoneMask (val, mask) {
      if (typeof val === 'string') {
        this.phone = masks[mask](val)
        this.filters.search = val.replace(/\D/g, '')
      }
    },

    handleSearch: debounce(function () {
      this.$emit('change', this.filters)
    }, 1000),

    reset () {
      this.phone = ''
      this.filters.search = ''
      this.$emit('change', this.filters)
    }
  },
  watch: {
    phone (val) {
      if (!val) {
        this.reset()
        return
      }

      if (val && typeof val === 'string' && (val.length === 14 || val.length === 15)) {
        this.handleSearch()
      }
    }
  }
}
</script>
